import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import Logo from 'new-components/shapes/Logo';

import { appBar, toolbar } from './styles';

const Header = () => {
  return (
    <AppBar position='fixed' className={appBar}>
      <Toolbar className={toolbar}>
        <Logo />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
